// Multivariate Dependencies
import React from 'react';
// Components
import { Container } from '../../../common/styles/container/styles/Container';
import { Heading } from '../../../atoms/Heading';
import { Divider } from '../../../atoms/Divider';
import { Paragraph } from '../../../atoms/Paragraph';
import { ModalBackground } from '../../ModalBackground';
// Types
import { grey } from '../../../common/styles/colours';
export var ModalStructure = function (_a) {
    var heading = _a.heading, subheading = _a.subheading, children = _a.children, leftFooterSection = _a.leftFooterSection, rightFooterSection = _a.rightFooterSection, onBackgroundClick = _a.onBackgroundClick, className = _a.className;
    return (React.createElement(ModalBackground, { onBackgroundClick: onBackgroundClick },
        React.createElement(Container, { className: className },
            React.createElement(Container, { display: 'grid', padding: '16px', gridRowGap: '8px' },
                React.createElement(Heading, { size: 'small' }, heading),
                subheading && React.createElement(Paragraph, { size: 'small' }, subheading)),
            React.createElement(Divider, { orientation: 'horizontal', borderStyle: 'solid' }),
            React.createElement(Container, { padding: '16px', height: 'fit-content' }, children),
            React.createElement(Divider, { orientation: 'horizontal', borderStyle: 'solid' }),
            React.createElement(Container, { padding: '16px', display: 'grid', backgroundColor: grey[100], gridTemplateColumns: 'repeat(2, 1fr)', alignContent: 'center', alignItems: 'center', borderRadius: '4px' },
                React.createElement(Container, { justifySelf: 'start' }, leftFooterSection),
                rightFooterSection && React.createElement(Container, { justifySelf: 'end' }, rightFooterSection)))));
};
//# sourceMappingURL=ModalStructure.js.map